<script setup lang="ts">
import { useMicrosoftOAuthStore } from '@/@vxapp/MicrosoftOAuth/useMicrosoftOAuthStore'
import MicrosoftMailWorkspace from '@/views/setup/microsoft-oauth/MicrosoftMailWorkspace.vue'
import MicrosoftOAuthSettingsCard from '@/views/setup/microsoft-oauth/MicrosoftOAuthSettingsCard.vue'
import { AccessPageMeta } from '@/access/accessPageMeta'

const microsoftOAuthStore = useMicrosoftOAuthStore()

definePage({
  meta: {
    ...AccessPageMeta.MicrosoftOAuth.Settings.Meta,
    pageTitle: PageMeta.MicrosoftOAuth.Settings.Title,
  },
})
</script>

<template>
  <VRow data-testid="microsoft-oauth-page">
    <VCol
      cols="12"
      data-testid="microsoft-oauth-settings-section"
    >
      <MicrosoftOAuthSettingsCard />
    </VCol>

    <VCol
      v-if="microsoftOAuthStore.status?.isLinked"
      cols="12"
      data-testid="microsoft-mail-workspace-section"
    >
      <MicrosoftMailWorkspace />
    </VCol>
  </VRow>
</template>
